export default __webpack_public_path__ + "static/media/sb.ce4d6414.svg";